@if (user.isAuth) {
  <div class="account-menu">
    <!-- Avatar -->
    <div class="avatar" (click)="toggleMenu()">
      <img src="{{ newAvatar ? newAvatar : user.avatar.small }}" alt="{{ user.name }} avatar" />
      <div class="triangle"></div>
    </div>
    <!-- Menu -->
    @if (isMenuOpen) {
      <div class="menu">
        <div class="bm--dropdown-triangle"></div>
        <div class="menu__container">
          <div class="menu__top">
            <img src="{{ newAvatar ? newAvatar : user?.avatar?.small }}" alt="{{ user?.name }} avatar" />
            <p>{{ user?.name }}</p>
          </div>
          <ul class="menu-dropdown">
            <li class="dropdown__item" [routerLink]="['/account', 'favorites']" (click)="closeAccountMenu()">
              <span class="btv-icon-heart"></span>
              <a class="dropdown__link">My favorites</a>
            </li>
            <li
              class="dropdown__item dropdown__item--divider"
              [routerLink]="['/account', 'purchases']"
              (click)="closeAccountMenu()"
            >
              <span class="btv-icon-purchase"></span>
              <a class="dropdown__link">Purchased tracks</a>
            </li>
            <li
              class="dropdown__item dropdown__item--divider"
              [routerLink]="['/account', 'edit']"
              (click)="closeAccountMenu()"
            >
              <span class="btv-icon-profile"></span>
              <a class="dropdown__link">Edit profile</a>
            </li>
            <li class="dropdown__item dropdown__item--divider">
              <span class="btv-icon-house"></span>
              <a class="dropdown__link" href="{{ adminAccountUrl }}"> Artist Administration </a>
            </li>
            @if (user.isBeatmaker) {
              <li
                class="dropdown__item dropdown__item--divider"
                [routerLink]="['/subscriptions']"
                (click)="closeAccountMenu()"
              >
                <span class="icon-btn-list"></span>
                <a class="dropdown__link">Subscription</a>
              </li>
            }
            <li class="dropdown__item" [routerLink]="['/account']" (click)="logout()">
              <span class="icon-logout"></span>
              <a class="dropdown__link">Logout</a>
            </li>
          </ul>
        </div>
      </div>
    }
  </div>
}
